import { Controller } from '@hotwired/stimulus';

/*
eslint class-methods-use-this:
["error", { "exceptMethods": ["updateTableCheckboxes", "updateHeaderCheckbox"] }]
*/
export default class extends Controller {
  static targets = ['headerCheckbox', 'checkbox'];

  updateTableCheckboxes () {
    const { checked } = this.headerCheckboxTarget;

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  updateHeaderCheckbox () {
    if (this.hasHeaderCheckboxTarget) {
      const checkedCount = Array.from(this.checkboxTargets)
        .filter(checkbox => checkbox.checked).length;
      if (checkedCount === 0) {
        this.headerCheckboxTarget.checked = false;
        this.headerCheckboxTarget.indeterminate = false;
      } else if (this.checkboxTargets.length === checkedCount) {
        this.headerCheckboxTarget.checked = true;
        this.headerCheckboxTarget.indeterminate = false;
      } else {
        this.headerCheckboxTarget.checked = false;
        this.headerCheckboxTarget.indeterminate = true;
      }
    }
  }
}
